import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';

import { routes } from './app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';

import { provideAngularSvgIcon } from 'angular-svg-icon';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTanStackQuery } from '@tanstack/angular-query-experimental';
import { createQueryClient } from './core/constants/query-client';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { environment } from '../environments/environment';
import { messaging } from '../configs/firebase.config';
import { TokenService } from './core/services/token.service';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    TokenService,

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // provideClientHydration(),
    // Una sola configuración: dos provideHttpClient se pisaban entre sí.
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAngularSvgIcon(),
    provideTanStackQuery(createQueryClient()),
    provideAnimations(), // required animations providers
    provideToastr({
      timeOut: 1200,
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'increasing',
    }),
    // temp . please save in environment
    provideFirebaseApp(() =>
      initializeApp({
        projectId: 'aljhamar-7d834',
        appId: '1:222287467199:web:79b7a7d772fb1af3e06c0a',
        storageBucket: 'aljhamar-7d834.firebasestorage.app',
        apiKey: 'AIzaSyAfFjG-bfiGrmq2M4OrnE3MFiuXG750j3o',
        authDomain: 'aljhamar-7d834.firebaseapp.com',
        messagingSenderId: '222287467199',
        measurementId: 'G-S875GQ5VNV',
      })
    ),
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    { provide: 'messaging', useValue: messaging },

    provideMessaging(() => getMessaging()), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }),
  ],
};
